import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';

/**
 * "Avísame cuando vuelva" block.
 * Re-renders itself when the selected variant changes (the product page only morphs the
 * variant picker, every other block updates from the HTML carried by the variant:update event).
 */
class BackInStockComponent extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.update);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.update);
  }

  /**
   * @param {CustomEvent} event - The variant update event.
   */
  update = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = event.detail.data.html.querySelector(
      `back-in-stock-component[data-block-id="${this.dataset.blockId}"]`
    );
    if (!next) return;

    this.dataset.variantId = next.dataset.variantId || '';
    morph(this, next, { childrenOnly: true });
  };
}

if (!customElements.get('back-in-stock-component')) {
  customElements.define('back-in-stock-component', BackInStockComponent);
}
